import { WatchfaceDeviceType } from '@/hooks';
import { TranslationLocale } from '@/store/use-translation-store';
import translationData from './widget-translations.json';

// ---- 类型定义 ----

interface TranslationItem {
  key: string;
  translations: Record<string, string>;
  deviceRules?: {
    excludeDevice?: string[];
  };
  // 标记为 true 时，该条目仅作为翻译数据源（如导出时查表），不出现在编辑器下拉框中
  hiddenInDropdown?: boolean;
}

/**
 * 所有 Widget 翻译 key 的联合类型
 * 数据来源：widget-translations.json
 */
export type WidgetTranslationKey = (typeof translationData)['items'][number]['key'];

// ---- 按语言索引的翻译表（兼容现有消费方） ----

export const widgetTranslations: {
  [key in TranslationLocale]: Partial<Record<WidgetTranslationKey, string>>;
} = (() => {
  const result: Record<string, Record<string, string>> = {};
  for (const locale of translationData.locales) {
    result[locale] = {};
  }
  for (const item of translationData.items as TranslationItem[]) {
    for (const [locale, value] of Object.entries(item.translations)) {
      if (result[locale]) {
        result[locale][item.key] = value;
      }
    }
  }
  return result as {
    [key in TranslationLocale]: Partial<Record<WidgetTranslationKey, string>>;
  };
})();

// ---- 设备过滤（兼容现有消费方） ----

export const getDeviceTranslations = (
  deviceType: WatchfaceDeviceType
): { label: string; value: string }[] => {
  return (translationData.items as TranslationItem[])
    .filter((item) => {
      // 仅作翻译数据源的条目不出现在下拉框
      if (item.hiddenInDropdown) return false;
      const rules = item.deviceRules;
      if (!rules) return true;
      if (
        rules.excludeDevice &&
        rules.excludeDevice.includes(deviceType as string)
      )
        return false;
      return true;
    })
    .map((item) => ({
      label: item.translations['zh_CN'] ?? item.key,
      value: item.key
    }));
};
